import { Component, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateService } from '@ngx-translate/core';
import { AnnoncementModelComponent } from '../modules/shared/annoncement-model/annoncement-model.component'
import { CommonService } from 'src/modules/shared/services/common.service';
import { DataSharingService } from 'src/modules/shared/services/DataSharing.service';
import { UserConfigService } from 'src/modules/shared/services/userConfig.service';
import { AppConfigService } from 'src/modules/shared/services/app-config.service';
import { IGetOperationResponse } from 'src/modules/shared/interfaces/IGetOperationResponse';
import { BsModalRef, ModalDirective, BsModalService } from 'ngx-bootstrap/modal';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { Router } from '@angular/router';
import { Subscription, timer } from 'rxjs';
import { ITokenResult } from 'src/modules/shared/interfaces/ITokenResult';
import { IKeyValuePair } from 'src/modules/shared/interfaces/IKeyValuePair';
import { EKeyAuthService } from 'src/modules/shared/services/Ekey-auth.service';
import { TokenResponse } from 'src/modules/shared/interfaces/ITokenResponse';

@Component({
  providers: [HttpClient],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})


export class AppComponent {
  title = 'MTT-Portal';
  cssUrl = '';
  dir = '';
  currentLang = 'ar';
  //private cssEn = './assets/css/styles.css';
  private cssAr = '../assets/css/styles-ar.min.css';
  //private cssAr = './assets/css/styles-ar.css';
  private cssEn = '../assets/css/styles.min.css';
  private dirAr = 'rtl';
  private dirEn = 'ltr';
  MTTCSSLink = "";
  baseUrl: string = "";

  @ViewChild(AnnoncementModelComponent) child: AnnoncementModelComponent;

  isProduction: boolean = false;
  isEKey: boolean = false;
  isEKey2: boolean = false;
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  idleitle = 'angular-idle-timeout';

  countDown: Subscription;
  tokenCounter: number = 180;
  tick = 1000;
  stopTimer: boolean = false;
  isMinuteToGo: boolean = false;
  RefreshTokenValue: string;
  public modalRef: BsModalRef;
  @ViewChild('childModal', {}) childModal: ModalDirective;
  @ViewChild('tokenModal', {}) tokenModal: ModalDirective;

  constructor(private translate: TranslateService,
    private commonService: CommonService,
    private sharedDataService: DataSharingService,
    private userConfigService: UserConfigService,
    private appConfig: AppConfigService,
    private idle: Idle,
    private keepalive: Keepalive,
    private modalService: BsModalService,
    private router: Router,
    private authService: EKeyAuthService) {

    this.baseUrl = this.appConfig.getAppConfig().AppUrl + '/api/App/';
    this.currentLang = localStorage.getItem('lang') || "en";
    localStorage.setItem('lang', this.currentLang);
    this.cssUrl = this.currentLang === 'ar' ? this.cssAr : this.cssEn;
    this.dir = localStorage.getItem('lang') === 'ar' ? this.dirAr : this.dirEn;
    translate.use(this.currentLang);


    debugger;
    this.isEKey2 = JSON.parse(this.appConfig.getAppConfig().IsEKey2);
    this.isEKey = JSON.parse(this.appConfig.getAppConfig().IsEKey);

    this.commonService.IsProduction(["IsProduction"], this.baseUrl).subscribe((response: IGetOperationResponse<Array<IKeyValuePair>>) => {
      if (response && response.Result) {
        var prodConfig = response.Result.find(el => el.Key == "IsProduction");
        if (prodConfig && prodConfig.Value == "true") {
          this.isProduction = true;
        }
        else {
          this.isProduction = false;
        }
      }
    }

    );
    this.sharedDataService.tokenExpiryTimeValue.subscribe(value => {
      this.tokenCounter = value;
    });
    // listen for changes to localStorage
    if (window.addEventListener) {
      window.addEventListener("storage", commonService.sessionStorage_transfer, false);
    } else {
      (<any>window).attachEvent("onstorage", commonService.sessionStorage_transfer);
    };


    // Ask other tabs for session storage (this is ONLY to trigger event)
    if (!sessionStorage.length) {
      localStorage.setItem('getSessionStorage', 'foobar');
      localStorage.removeItem('getSessionStorage');
    };
    //-----------------Idle Configuration------------------
    // sets an idle timeout of 5 seconds, for testing purposes.
    this.sharedDataService.idleTimeoutValue.subscribe(value => {
      if (value == 0) {
        value = 900
      }
      idle.setIdle(value);
    });
    // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
    this.sharedDataService.InactivityTimeValueForAutomaticLogout.subscribe(value => {
      idle.setTimeout(value);
    });
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => {
      //this.idleState = 'No longer idle.'
      this.reset();
    });

    idle.onTimeout.subscribe(() => {
      this.childModal.hide();
      this.translate.get("SessionIdleAndExpiration.Labels.idleStateTimedOut"
      ).subscribe(value => this.idleState = value);
      this.timedOut = true;

      this.logout();
    });

    idle.onIdleStart.subscribe(() => {
      this.translate.get("SessionIdleAndExpiration.Labels.idleStateGoneIdle"
      ).subscribe(value => this.idleState = value);
      this.childModal.show();
    });

    idle.onTimeoutWarning.subscribe((countdown) => {
      this.translate.get("SessionIdleAndExpiration.Labels.IdleTimeoutMsg"
      ).subscribe(value => this.idleState = value);


    });

    // sets the ping interval to 15 seconds
    keepalive.interval(10);

    keepalive.onPing.subscribe(() => this.lastPing = new Date());

    this.sharedDataService.isUserLoggedIn.subscribe(userLoggedIn => {
      if (userLoggedIn) {
        idle.watch()
        this.timedOut = false;
      } else {
        idle.stop();
      }
    })

  }
  ngAfterViewInit() {
    document.getElementById('MTTCSSLink').setAttribute('href', this.cssUrl);
    document.getElementById('html').setAttribute('dir', this.dir);
  }
  HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
  }
  reset() {
    this.idle.watch();
    //xthis.idleState = 'Started.';
    this.timedOut = false;
  }

  hideChildModal(): void {
    this.childModal.hide();
  }
  hideTokenModal(): void {
    this.tokenModal.hide();
  }

  stay() {
    this.childModal.hide();
    this.reset();
  }

  logout() {
    this.childModal.hide();
    this.tokenModal.hide();
    this.tokenModal.hide();
    this.userConfigService.logOut()
  }
  ngOnInit(): void {
    this.sharedDataService.isUserLoggedIn.subscribe(userLoggedIn => {
      if (userLoggedIn) {
        this.countDown = timer(0, this.tick)
          .subscribe(() => {
            if (this.tokenCounter > 0) {
              --this.tokenCounter;
            } else if (this.tokenCounter == 0 && !this.stopTimer && !this.isMinuteToGo) {
              this.stopTimer = true
              this.tokenModal.show();
              this.tokenCounter += 59;
            } else if (this.tokenCounter == 0 && this.stopTimer && !this.isMinuteToGo) {
              this.isMinuteToGo = true
              this.logout();
            }
            sessionStorage.setItem("tokenCounter", this.tokenCounter.toString());
          })
      }
    })
  }
  ngOnDestroy() {
    this.countDown.unsubscribe();
  }

  refreshToken() {
    this.userConfigService.refreshAccessToken().subscribe(
      (response: IGetOperationResponse<ITokenResult>) => {
        if (response && response.Result) {
          sessionStorage.setItem("Access-Token", response.Result.AccessTokenValue);
          this.tokenCounter = (response.Result.TokenExpiryTimeValue - 1) * 60;
          this.sharedDataService.tokenExpiryTimeValue.next(this.tokenCounter);
          this.stopTimer = false;
          this.tokenModal.hide();
        }
      },
      (err) => {
      },
      () => console.log('Calling api complete'));
  }

  refreshTokenEkeyTwo() {
    console.log("Enter  refreshTokenEkeyTwo Method ........ ");
    this.RefreshTokenValue = sessionStorage.getItem('ekey_refresh_token');
    console.log("this.RefreshTokenValue  = " + this.RefreshTokenValue);

    this.authService.refreshToken(this.RefreshTokenValue).subscribe(
      (response: IGetOperationResponse<TokenResponse>) => {
        if (response && response.Result) {
          sessionStorage.setItem("Access-Token", response.Result.access_token);
          sessionStorage.setItem("ekey_access_token", response.Result.access_token);
          sessionStorage.setItem("ekey_refresh_token", response.Result.refresh_token);

          this.tokenCounter = (response.Result.expires_in - 1);
          this.sharedDataService.tokenExpiryTimeValue.next(this.tokenCounter);
          this.stopTimer = false;
          this.tokenModal.hide();
        }
      },
      (err) => {
      },
      () => console.log('Calling api complete'));
  }
}
